import Cookies from 'js-cookie'

export default class Newsletter extends HTMLElement {
    private open: boolean = false
    private delay: number = 1200
    private frequency: number = 7

    private container: HTMLElement | null = null
    private backdrop: HTMLElement | null = null
    private formElement: HTMLFormElement | null = null
    private closeButton: HTMLButtonElement | null = null

    private titleElement: HTMLElement | null = null
    private subtitleElement: HTMLElement | null = null
    private buttonElement: HTMLButtonElement | null = null

    private cloudflareKlaviyoUrl: string = 'https://rodeo-klaviyo-subscribe.hi-f17.workers.dev'

    static get observedAttributes() {
        return ['email', 'open']
    }

    constructor() {
        super()

        this.delay = parseInt(this.getAttribute('newsletter-delay') || '1200')
        this.frequency = parseInt(this.getAttribute('newsletter-frequency') || '7')

        // Check if the newsletter has been shown in the last 7 days
        const lastShown = Cookies.get('newsletterLastShown')
        const shouldShow = !lastShown || Date.now() > parseInt(lastShown) + this.frequency * 24 * 60 * 60 * 1000

        // Only show if it hasn't been shown in the last 7 days or if explicitly set to open
        this.open = shouldShow && !lastShown && this.hasAttribute('open') && this.getAttribute('open') === 'true'

        this.container = this.querySelector('[data-container]')
        this.backdrop = this.querySelector('[data-newsletter-backdrop]')
        this.formElement = this.querySelector('form')
        this.closeButton = this.querySelector('[data-close]')
        this.titleElement = this.querySelector('[data-title]')
        this.subtitleElement = this.querySelector('[data-subtitle]')
        this.buttonElement = this.querySelector('button[data-button]')

        console.log('this.buttonElement', this.buttonElement)

        if (this.formElement) {
            this.formElement.addEventListener('submit', this.handleFormSubmit.bind(this))
        }

        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.handleCloseButtonClick.bind(this))
        }

        if (this.backdrop) {
            this.backdrop.addEventListener('click', this.handleBackdropClick.bind(this))
        }

        // Listen for newsletter toggle events from announcement bar
        // @ts-ignore
        ;(window as any).addEventListener('newsletter:toggle', (evt: CustomEvent) => {
            const open = evt.detail.open

            this.isOpen = open
        })

        if (this.open) {
            this.container?.classList.remove('hidden')
            this.backdrop?.classList.remove('hidden')

            setTimeout(() => {
                this.backdrop?.classList.remove('!opacity-0')

                // Body
                document.body.style.height = '100vh'
                document.body.style.overflow = 'hidden'
            }, this.delay)

            setTimeout(() => {
                this.container?.classList.add('!opacity-100')
            }, this.delay + 250)
        }
    }

    get isOpen() {
        return this.open
    }

    set isOpen(value: boolean) {
        this.open = value
        this.toggle()
        // Cookies.set('newsletterOpen', value.toString())
    }

    handleCloseButtonClick(evt: Event) {
        evt.preventDefault()
        // Set cookie with current timestamp when closing
        Cookies.set('newsletterLastShown', Date.now().toString(), { expires: 7 })
        this.isOpen = false
    }

    handleBackdropClick(evt: Event) {
        evt.preventDefault()
        // Set cookie with current timestamp when closing
        Cookies.set('newsletterLastShown', Date.now().toString(), { expires: 7 })
        this.isOpen = false
    }

    async handleFormSubmit(evt: Event) {
        evt.preventDefault()

        if (this.buttonElement) {
            this.buttonElement.textContent = 'Submitting...'
            this.buttonElement.disabled = true
        }

        const form = evt.target as HTMLFormElement
        form.classList.add('pointer-events-none')

        const formData = new FormData(form)
        const email = formData.get('email')
        console.log('email', email)

        const body = {
            email: email,
        }

        try {
            const response = await fetch(this.cloudflareKlaviyoUrl, {
                method: 'POST',
                body: JSON.stringify(body),
            })

            // If response is not ok, throw an error with the status
            /*
            if (!response.ok) {
                const error = new Error('Subscription failed')
                ;(error as any).status = response.status
                throw error
            }
            */

            const data = await response.json()

            if (data.success) {
                if (this.titleElement) {
                    this.titleElement.textContent = 'Success'
                }
                if (this.subtitleElement) {
                    this.subtitleElement.textContent = 'Thank you for subscribing!'
                }
            }
        } catch (error) {
            // Check if this is a 409 error (already subscribed)
            if ((error as any).status === 409) {
                if (this.titleElement) {
                    this.titleElement.textContent = 'You are already subscribed!'
                }
                if (this.subtitleElement) {
                    this.subtitleElement.textContent = 'Thank you for your continued support.'
                }
            } else {
                // Handle other errors
                if (this.titleElement) {
                    this.titleElement.textContent = 'Error'
                }

                if (this.subtitleElement) {
                    this.subtitleElement.textContent = 'Something went wrong. Please try again later.'
                }
            }
        } finally {
            // Re-enable the form after a short delay
            setTimeout(() => {
                if (this.buttonElement) {
                    this.buttonElement.textContent = 'Subscribe'
                    this.buttonElement.disabled = false
                }
                form.classList.remove('pointer-events-none')
            }, 2000)

            setTimeout(() => {
                this.isOpen = false

                if (this.titleElement) {
                    this.titleElement.textContent = 'Subscribe'
                }

                if (this.subtitleElement) {
                    this.subtitleElement.textContent = ''
                }
            }, 7500)
        }
    }

    toggle() {
        if (!this.isOpen) {
            this.container?.classList.add('hidden')
            this.container?.classList.remove('!opacity-100')
            this.backdrop?.classList.add('hidden')
            this.backdrop?.classList.add('!opacity-0')

            document.body.style.height = ''
            document.body.style.overflow = ''
        } else {
            this.container?.classList.remove('hidden')
            this.backdrop?.classList.remove('hidden')
            document.body.style.height = '100vh'
            document.body.style.overflow = 'hidden'

            setTimeout(() => {
                this.backdrop?.classList.remove('!opacity-0')
            }, 20)

            setTimeout(() => {
                this.container?.classList.add('!opacity-100')
            }, 250)
        }
    }
}

customElements.define('shop-newsletter', Newsletter)
